<template>
  <el-dialog
    class="modal-modify-type"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    custom-class="greater"
  >
    <div class="content">
      <h3 class="title">基本信息配置</h3>
      <el-form
        ref="modifyType1"
        :rules="rules"
        label-position="top"
        label-width="80px"
        :model="formData"
        class="type-modify__form1"
        @submit.native.prevent
      >
        <el-form-item label="供应商类型名称:" prop="typeName">
          <el-input
            v-model="formData.typeName"
            placeholder="必填"
            style="width: 440px;"
          ></el-input>
          <span
            class="input-tips"
          >*支持32个中文字符或64个英文字符,并只包含.。，,()（）【】[]、\_-— 以上字符</span>
        </el-form-item>

        <el-form-item label="平台编码:" prop="fromSysCode">
          <el-input v-model="formData.fromSysCode" placeholder="选填" style="width: 440px;"></el-input>
          <span class="input-tips">*支持16个中文字符或32个英文字符,并只包含.。，,()（）【】[]、\_-— 以上字符</span>
        </el-form-item>

        <el-form-item label="推送URL:">
          <el-input v-model="formData.pushUrl" placeholder="选填" style="width: 440px;"></el-input>
        </el-form-item>

        <el-form-item label="备注:" prop="note">
          <el-input
            type="textarea"
            style="width: 500px; height: 48px;"
            resize="none"
            maxlength="50"
            placeholder="选填, 可填入50个字符"
            v-model="formData.note"
          ></el-input>
          <span
            class="input-tips"
          >*支持中文、字母、数字, 最多50字, 并且不包含 &#47;&#96;&#42;&#38;&#94;&#34;&#35;&#33;&#36; 等特殊字符</span>
        </el-form-item>
      </el-form>

      <h3 class="title">接口配置</h3>
      <el-form
        ref="modifyType2"
        :rules="rules"
        label-position="top"
        label-width="80px"
        :model="formData"
        class="type-modify__form2"
        @submit.native.prevent
      >
        <el-form-item>
          <cd-transfer :selecteds.sync="formData.apis"></cd-transfer>
        </el-form-item>

       
        <el-form-item class="status__item" label="状态:">
          <el-radio-group v-model="formData.status" style="margin-top: 6px;">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="save__btn" @click="$_submit">保存</el-button>
      <el-button @click="$_cancle" class="cancel__btn">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import cdTransfer from "./transfer";

export default {
  name: "modal-modify-type",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,

      statuses: [{ value: 1, label: "启用" }, { value: 2, label: "停用" }],
      formData: {
        tid: -1,
        fromSysCode: "",
        typeName: "",
        apis: [],
        status: 1, // 状态 1 - 启用, 2 - 停用
        note: "",
        pushUrl: "",
      },

      rules: {
        typeName: [
          { required: true, message: "请输入类型名称" },
          {
            validator: (rule, value, callback) => {
              if (typeof value !== "undefined" && value !== "") {
                if (Utils.getStrLength(value) > 64) {
                  callback(new Error(`32个中文字符或64个英文字符`));
                  return false;
                } else if (
                  value.match(
                    /^[\u0391-\uFFE5A-Za-z0-9.。，,()（）【】\[\]、\\_\-—]+$/
                  ) == null
                ) {
                  callback(
                    new Error("只包含 .。，,()（）【】[]、\\_-— 以上字符")
                  );
                  return false;
                }
              }
              callback();
            },
            trigger: "blur"
          },
        ],
        fromSysCode: [
          {
            validator: (rule, value, callback) => {
              if (typeof value !== "undefined" && value !== "") {
                if (Utils.getStrLength(value) > 32) {
                  callback(new Error(`16个中文字符或32个英文字符`));
                  return false;
                } else if (
                  value.match(
                    /^[\u0391-\uFFE5A-Za-z0-9.。，,()（）【】\[\]、\\_\-—]+$/
                  ) == null
                ) {
                  callback(
                    new Error("只包含 .。，,()（）【】[]、\\_-— 以上字符")
                  );
                  return false;
                }
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        note: [
          {
            validator: (rule, value, callback) => {
              if (Utils.getStrLength(value) > 100) {
                callback(new Error("最多50个中文字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
          { validator: Utils.validCharmap, trigger: "blur" }
        ]
      },
      modal: {
        show: false,
        title: "",
        data: {}
      }
    };
  },
  methods: {
    // 保存
    $_submit() {
      if (!this.formData.apis.length) {
        $MessageBox.alert({ content: "请选择系统接口!" });
        return false;
      }
      this.$refs["modifyType1"].validate(valid => {
        if (valid) {
          const self = this;
          let action = "addSupplierType";
          let apiIds = [];
          this.formData.apis.forEach(item => {
            apiIds.push(item.pid);
          });
          let postData = {
            typeName: this.formData.typeName,
            status: this.formData.status,
            apiIds,
            fromSysCode: this.formData.fromSysCode,
            pushUrl: this.formData.pushUrl,
          };
          if (this.formData.note) {
            Object.assign(postData, { note: this.formData.note });
          }
          if (self.formType === "edit") {
            action = "editSupplierType";
            Object.assign(postData, { tid: self.formData.tid });
          }
          self.$service.post(action, postData).then(result => {
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.visible = false;
                  self.$emit("callback");
                }
              });
            }
          });
        }
      });
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created() {
    if (this.formType === "edit") {
      this.formData.tid = this.modalData.tid;
      this.formData.typeName = this.modalData.typeName;
      this.formData.apis = [...(this.modalData.apiList || [])];
      this.formData.note = this.modalData.note || "";
      this.formData.status = this.modalData.status;
      this.formData.fromSysCode = this.modalData.fromSysCode;
      this.formData.pushUrl = this.modalData.pushUrl;
    }
  },
  mounted() {
    this.visible = true;
  },
  components: {
    cdTransfer
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 12px;
  .title {
    padding-left: 20px;
    height: 32px;
    color: #3a3a3a;
    font-size: 14px;
    font-weight: 700;
  }
}
.type-modify__form1,.type-modify__form2 {
  padding-left: 20px;
}
/deep/ .transfer-wrapper .transfer__left{
width:460px
}
/deep/ .transfer-wrapper .transfer__right{
width:460px
}
/deep/ .input-tips{
  margin-left:10px;
}
/deep/ .el-table{
  background-color: rgb(245, 245, 245);
}
</style>
